import React, { Component, useState, useEffect, useRef } from 'react';
import { Link, useParams, Router, useNavigate } from 'react-router-dom';
import { Row, Col, Container, Button, ModalHeader, ModalFooter, Modal, ModalBody, Alert } from "reactstrap";

import $ from "jquery";
import Header from '../header.js';
import Faculty from '../Faculty/Faculty.js';
import Footer from '../footer.js';
import scan from '../../images/scan.png';
import play from '../../images/play.png';
import bnrimg from '../../images/bnrimg.png';

import web1 from '../../images/web1.png';
import web2 from '../../images/web2.png';
import web3 from '../../images/web3.png';
import web4 from '../../images/web4.png';
import web5 from '../../images/web5.png';
import web6 from '../../images/web6.png';
import aboutimg from '../../images/aboutimg.png';
import { API_URL } from '../../../Config/index.js';

 

const Create = () => {

    const [show, setShow] = useState(true)
    const [submitted, setSubmitted] = useState(false)
    const [userId, setUserId] = useState(null)
    const [creating,  setCreating] = useState(false)
    const [showCheckout,  setShowCheckout] = useState(true)
    
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [confirmemail, setConfirmEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [telofficeNo, setTelofficeNo] = useState('');
    const [telcellNo, setTelcellNo] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [country, setCountry] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [postalcode, setPostalcode] = useState('');
    const [profession, setProfession] = useState('');
    const [highestdegreeearned, setHighestdegreeearned] = useState('');
    const [degreeinwhatfield, setDegreeinwhatfield] = useState('');
    const [yeardegreeearned, setyeardegreeearned] = useState('');
    const [licenses, setLicenses] = useState('');
    const [certifications, setCertifications] = useState('');
    const [yearsofprofessionalexperience, setYearsofprofessionalexperience] = useState('');
    const [whoreferredyou, setWhoreferredyou] = useState('');
    const [loginModel, setLoginModel] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const LoginToggleModal = () => setLoginModel(!loginModel);
 
    const referer = localStorage.getItem('referer');
    const [registering, setRegistering] = useState(false);
    const [logging, setLogging] = useState(false);

    const totalCost = localStorage.getItem('totalCost')
    const balanceAmount = localStorage.getItem('balanceAmount')
    const classes = localStorage.getItem('classes')
    const [existingUserId, setExistingUserId] = useState(null);

    const cvFile = useRef()

    const [successModal, setsuccessModal] = useState(false);
    const [programRequisitModal, setProgramRequisitModal] = useState(false);
    const [prereq, setPrereq] = useState(null);
    const successToggleModal = () => setsuccessModal(!successModal);

    const [messageModal, setmessageModal] = useState(false);
    const messageToggle = () => setmessageModal(!messageModal);
    const [message, setmessage] = useState(false);
    const [messageHead, setmessageHead] = useState(false);
    const [showOtherRefer, setShowOtherRefer] = useState(false);
    const [source, setSource] = useState(null);
      const [rentalOption, setRentalOption] = useState(null);
      const [rentalOpted, setRentalOpted] = useState(null);
    
    const trimester = localStorage.getItem('trimester');

     const [balanceAmountDiscount, setBalanceAmountDiscount] = useState(0);
    const [totalCostDiscount, setTotalCostDiscount] = useState(0);

    const [scholarshipCode, setScholarshipCode] = useState(null);
    const [poNumber, setPoNumber] = useState(null);
    const [scapplied, setScapplied] = useState(null);
    const [poapplied, setPoapplied] = useState(null);
    const [codeError, setCodeError] = useState(null);

    const [paymentOption, setPaymentOption] = useState("deposit");
    const [installmentDates, setInstallmentDates] = useState([]);
    const [instalmentEnabled, setInstalmentEnabled] = useState(false);
    const installmentFee = 50;
    


    const [countries,setCountries] = useState([])
    
    const [payPalModal, setPayPalModal] = useState(false);
    const payPalToggle = () => setPayPalModal(!payPalModal);
 
    const Navigate = useNavigate();
    // const [alert, setAlert] = useState(false);
    const [price, setPrice] = useState(100);
    
    const [states,setStates] = useState([])

    useEffect(() => {        
        getStates();
     },[country])
    
    const getStates = async () => {
        const response = await fetch(API_URL+"/states?country_id="+country, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            
        })

         const data = await response.json()
         if(data.msg == "success"){
            setStates(data.states)
         }
        
    }



    const LoginUser = async () => {
      

        // result = await result.json();
        // console.warn(result);
        // setAlert(false);
        // if (result.length > 0) {
        //     localStorage.setItem("user_id", JSON.stringify(result));
        //     Navigate('/');
        // }
        // else {
        //     setAlert(true);
        // }
    }

    useEffect(() => {
       getPrice()
       getCountries();
       getCourse();
    },[email])
    
      const getCourse = async () => {
        const response = await fetch(API_URL + "/get/course/" + classes, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
    
        const data = await response.json();
        if (data.success) {
            console.log("data",data.data?.[0]);
            
          // console.log(data.data[0].damount_new);
        //   setDepositEnabled(parseInt(data.data[0].pay_deposit_balance_day))
          setInstalmentEnabled(parseInt(data.data[0].pay_deposit_installment))
        //   setBrochureLink(data.data[0].course_url);
        //   setDamount_new(data.data[0].damount_new);
        //   setBamount_new(data.data[0].bamount_new);
          setRentalOption(data.data[0].rentalOption);
          setPrereq(data.data[0].Prereq);
          
    
        //   setDamount(data.data[0].damount);
        //   setBamount(data.data[0].bamount);
        //   setRawBalanceDate(data.data[0].bc_date * 1000)
        //   setBalanceDate(formatDate(data.data[0].bc_date))
    //       const timestamps = data.data[0].insfudates.split(",")
    //       const formattedDates = timestamps.map(ts => {
    //   return formatDate(ts);
    // });
    
    // setInstallmentDates(formattedDates)
    
    //       setPrice(data.data[0].price);
    //       setTotalActualCost(data.data[0].price);
    //       setTotalCost(data.data[0].price);
    //       setTrimester(data.data[0].semesters);
    //       setCourse(data.data[0].id);
    //       setCourseName(data.data[0].coursecode + " " + data.data[0].course);
        }
      };

    const formatDate = (ts) => {
        const date = new Date(ts * 1000); // Convert seconds to milliseconds
        return date.toLocaleDateString('en-US', { month: 'short', day: '2-digit', year: 'numeric' });
    }

    const getCountries = async () => {
        const response = await fetch(API_URL+"/countries/", {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            
        })

         const data = await response.json()
         if(data.status){
            setCountries(data.countries)
         }
        
    }
    const getPrice = async () => {
        const response = await fetch(API_URL+"/check/group?email="+email, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            
        })

         const data = await response.json()
         if(data.success){
            // setPrice(data.price)
         }
        
    }
    const savaFormDataTEST = () => {

    setmessageHead("Success!!")
    setmessage("Your registration was successful.<br /> <br /> You may log into the Professional School e-campus website any time at <a target='_blank' href='https://e-campus.bp.edu' ><u>www.e-campus.bp.edu</u></a> to access course materials and listen to recordings of previous sessions. You will be provided with details during the first course session. <br /> <br /> Thank you!  We look forward to seeing you.") ;
    messageToggle();
    }

    const validate = () => {
        let fields = [
            ['firstname', firstname, 'First Name'],
            ['lastname', lastname, 'Last Name'],
            ['email', email, 'Email Address'],
            ['confirmemail', confirmemail, 'Confirm Email Address'],
            ['password', password, 'Password'],
            ['confirmPassword', confirmPassword, 'Confirm Password'],
            ['telcellNo', telcellNo, 'Tel Cell Number'],
            ['address1', address1, 'Address Line 1'],
            ['country', country, 'Country'],
            ['state', state, 'State, province, other'],
            ['city', city, 'City'],
            ['postalcode', postalcode, 'Postal Code'],
        ];

        if(show){
            fields = fields.concat([
                ['profession', profession, 'Profession'],
                ['highestdegreeearned', highestdegreeearned, 'Highest degree earned'],
                ['degreeinwhatfield', degreeinwhatfield, 'Degree in what field'],
                ['yeardegreeearned', yeardegreeearned, 'Year degree earned'],
                ['licenses', licenses, 'Licenses'],
                ['certifications', certifications, 'Certifications'],
                ['yearsofprofessionalexperience', yearsofprofessionalexperience, 'Years of professional experience'],
                ['whoreferredyou', whoreferredyou, 'Who referred you'],
            ]);
        }

        let errs = {};
        fields.forEach(([key, value, label]) => {
            if(value == ''){
                errs[key] = label + " is required.";
            }
            else if(key == 'email' && !ValidateEmail(value)){
                errs[key] = "Email not valid.";
            }
            else if(key == 'confirmemail' && value != email){
                errs[key] = "Email doesn't match.";
            }
            else if(key == 'confirmPassword' && value != password){
                errs[key] = "Password doesn't match.";
            }
        });

        if(rentalOption==1 && rentalOpted == null){
            errs.rentalOpted = "Please select your choice for CapnoTrainer GO instrumentation requirement.";
        }

        return errs;
    }

    const fieldErrors = submitted ? validate() : {};
    const errorBorder = (key) => fieldErrors[key] ? { border: "1px solid red" } : undefined;
    const fieldError = (key) => fieldErrors[key] ? <small className='text-danger d-block'>{fieldErrors[key]}</small> : null;

    const savaFormData = () => {
        setSubmitted(true);
        const errs = validate();
        if(Object.keys(errs).length > 0){
            setmessageHead('Error!')
            setmessage("<b>Please enter the required fields:</b><br />" + Object.values(errs).map((v) => "&bull; " + v).join("<br />"))
            messageToggle();
            return false;
        }


        let _member = {
            firstname, lastname, email, confirmemail, password, confirmPassword, telofficeNo, telcellNo
            , address1, address2, country, state, city, postalcode, profession, highestdegreeearned, degreeinwhatfield, yeardegreeearned , trimester , classes
            , licenses, certifications, yearsofprofessionalexperience, whoreferredyou, show,source
        };

        let formData = new FormData();
    

        formData.append('fname', firstname);
        formData.append('lname', lastname);
        formData.append('email', email);
        formData.append('username', email);
        formData.append('password', password);
        formData.append('phone', telofficeNo);
        formData.append('mobile', telcellNo);
        formData.append('add1', address1);
        formData.append('add2', address2);
        formData.append('country', country);
        formData.append('state', state);
        formData.append('city', city);
        formData.append('zip', postalcode);
        formData.append('paymentoptions', 'deposit');
        formData.append('amount', parseFloat(totalCost -  totalCostDiscount).toFixed(2));
        formData.append('semsids', trimester);
        formData.append('classes', classes);
 if(rentalOption==1){
      formData.append("rentalOpted", rentalOpted);
    }
      
        if(show){
            formData.append('profession', profession);
            formData.append('highestdeg', highestdegreeearned);
            formData.append('degrefield', degreeinwhatfield);
            formData.append('yeardegree', yeardegreeearned);
            formData.append('licenses', licenses);
            formData.append('certifications', certifications);
            formData.append('experienceyears', yearsofprofessionalexperience);
            formData.append('referredyou', whoreferredyou);
            formData.append('referredfiled', source);
            formData.append('cv', cvFile.current.files[0]);
        }
      
setCreating(true);

        fetch(API_URL+'/create/user', {
            method: 'POST',
           
            body: formData
        }).then(async (result) => {
            // console.warn("result",result);
            const data = await result.json()
setCreating(false);

            if(data.status){
            //    setUserId(data.id)
            payPalToggle();

        setExistingUserId(data.id);

            
            //    setTimeout(() => {
            //         payNow(data.id) ;
            //    },2000)
            }
            else if(data.exist){
                setmessageHead('Error!')
                setmessage("You're an existing student. Please login to complete the registration")
                messageToggle();
            }
            else{
                setmessageHead('Error!')
                setmessage("Server Error.")
                messageToggle();


            }
        })


    }

    const applyponumber = async () => {
        
        setShowCheckout(true)
     

        let result = await fetch(API_URL+'/apply/ponumber', {
            method: 'POST',
            
            body: JSON.stringify({
                code : poNumber,
                payable: totalCost,
                balance : balanceAmount
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        result = await result.json();
        console.warn(result);
        setCodeError(false);
        setScapplied(false);
        setPoapplied(false);
        setTotalCostDiscount(0);
        setBalanceAmountDiscount(0);
        if (result.success) {
            if(result.exist){
                setTotalCostDiscount(result.payable);
                setBalanceAmountDiscount(result.balance)
                setPoapplied(true);
            //     setTimeout(() => {
            //         payNow(existingUserId) ;
            //    },2000)

            }
            else{
                setCodeError("Invalid PO Number")
            //     setTimeout(() => {
            //         payNow(existingUserId) ;

            //    },2000)

            }

            // Navigate('/');
        }
        else {
            setCodeError("Some Error Occured!!!")
        //     setTimeout(() => {
        //                             payNow(existingUserId) ;

        //    },2000)

        }
    }


    const applyscholarshipcode = async () => { 
        setShowCheckout(true)

        let result = await fetch(API_URL+'/apply/scholarship', {
            method: 'POST',
            
            body: JSON.stringify({
                couponcode : scholarshipCode,
                semsid :  trimester,
                payable: totalCost,
                balance : balanceAmount
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        });

        result = await result.json();
        console.warn(result);
        setCodeError(false);
        setScapplied(false);
        setPoapplied(false);
        setTotalCostDiscount(0);
        setBalanceAmountDiscount(0);
        if (result.success) {
            if(result.exist){
                setTotalCostDiscount(result.payable);
                setBalanceAmountDiscount(result.balance)
                setScapplied(true);
//                 setTimeout(() => {
//                     payNow(existingUserId) ;

// },2000)
            }
            else{
                setCodeError("Invalid Code")
//                 setTimeout(() => {
//                     payNow(existingUserId) ;

// },2000)
            }

            // Navigate('/');
        }
        else {
            setCodeError("Some Error Occured!!!")
        //     setTimeout(() => {
        //         payNow(existingUserId) ;

        // },2000)
        }
    }

    // const proceed = () => {
    //     $("#paypal-button-container").html('')
    //     payNow(existingUserId)
    // }
    useEffect(() => {
        if(existingUserId){
            // alert(existingUserId)
            payNow(existingUserId)
        }
       
    },[existingUserId,totalCostDiscount,totalCost,balanceAmount,balanceAmountDiscount,paymentOption]);

    const balanceDue = parseFloat(parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2));

    // installment due dates of the selected course (from its start date)
    useEffect(() => {
        if(!classes){
            return;
        }
        fetch(API_URL+'/get/installment/dates/'+classes)
            .then((res) => res.json())
            .then((data) => {
                if(data.success){
                    setInstallmentDates(data.dates);
                }
            })
            .catch((err) => console.error("Error fetching installment dates:", err));
    },[classes]);

    // balance split in 3 equal monthly installments from the course start date, fee added to the last one
    // (same calculation as getInstallmentSchedule in the api, the actual dates come from the api and are shown 2 days earlier here)
    const installmentCount = 3;
    const installmentDaysBefore = 2;
    const installments = instalmentEnabled == 1 && balanceDue > 0 && installmentDates.length == installmentCount ?
        Array.from({ length: installmentCount }, (_, i) => {
            const perInstallment = Math.floor((balanceDue / installmentCount) * 100) / 100;
            const isLast = i == installmentCount - 1;
            const amount = isLast ? balanceDue - perInstallment * (installmentCount - 1) + installmentFee : perInstallment;
            const date = formatDate(installmentDates[i] - installmentDaysBefore * 86400);
            return { date, amount: amount.toFixed(2), isLast };
        })
        : [];
    const payByInstallment = paymentOption == "installment" && installments.length > 0;

    const paymentOptionStyle = (option) => ({
        display: "flex",
        alignItems: "flex-start",
        gap: "10px",
        padding: "10px 12px",
        marginBottom: "10px",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "14px",
        border: paymentOption == option ? "2px solid #000" : "1px solid #00000052",
    });


    const payNow = (id) => {
        setShowCheckout(false)
        setRegistering(false)

        $("#paypal-button-container").html('')
         paypal.Buttons({
           createOrder: function(data, actions) {
             return actions.order.create({
               purchase_units: [{
                 amount: {
                   value: parseFloat(parseFloat(totalCost -  totalCostDiscount).toFixed(2))
                //    value: parseFloat(parseFloat(0.01).toFixed(2))
                 }
               }]
             });
           },
           onApprove: function (data, actions) {
               return actions.order.capture().then(function (details) {
                //   console.log(details)
                completeRegisteration(id,details) ; 
                  
                 })
               },
               onCancel: function (data) {
                  // window.location.replace("<?php echo $site_url;?>sales/CeRegister_new_back.php")
               }
         }).render('#paypal-button-container');
         
    }

    const completeRegisteration = async (id,details,_cost,_balanceAmount) => {
        setRegistering(true)
          
           let semsids = trimester
           const response = await fetch(API_URL+'/complete/registration/new/installment/'+id, {
               method: 'POST',
               headers: {
                   'Content-Type': 'application/json',
               },
               body: JSON.stringify({
                classes : classes,
                semsids : semsids,
                details,
                paidAmount : parseFloat(parseFloat(totalCost -  totalCostDiscount).toFixed(2)),
                discountcoupon : scholarshipCode,
                pocode : poNumber,
                balance : balanceDue,
                referer: referer,
                // saved as users_billing.paymentoption, the api creates the installment / deposit rows from it
                paymentMethod: payByInstallment ? "installment" : balanceDue > 0 ? "deposit" : "full",
                ...(payByInstallment ? { customerId: 0, paymentMethodToken: 0 } : {})
               }),
           })
    
    
    
           const data = await response.json()
    
           if(data.status){
               setmessageHead("Success!!")
               if(classes == 780){
                setmessage("Your registration was successful.<br /> <br /> You may log into the Professional School e-campus website any time at <a target='_blank' href='https://e-campus.bp.edu' ><u>www.e-campus.bp.edu</u></a> to access course materials (assignments, files, slides, practicum instructions), listen to the prerecorded modules, take module quizzes, access your Professional School CapnoLearning Database, listen to recordings of live sessions (the Orientation, 4-Q&A, and the Practicum Interview), and make an appointment for your Practicum Interview. <br /> <br /> If you are previous student and or have simultaneously signed up for another course, you can access the main e-campus site by clicking on “e-campus” header that will appear on the CapnoLearning landing page.<br /> <br /> You will now be auto-redirected to e-campus in 30 seconds.") ;

               }
               else{
                setmessage("Your registration was successful.<br /> <br /> You may log into the Professional School e-campus website any time at <a target='_blank' href='https://e-campus.bp.edu' ><u>www.e-campus.bp.edu</u></a> to access course materials and listen to recordings of previous sessions. You will be provided with details during the first course session. <br /> <br /> Thank you!  We look forward to seeing you. <br /> <br /> You will now be auto-redirected to e-campus in 30 seconds.") ;
               }
               messageToggle();
                payPalToggle() ; 

                // setTotalCost(0) ;
                // setOrderedItems([])
               setTimeout(() => {
                    if(classes == 780){
                        window.location.replace("https://e-learning-client-dun.vercel.app/authenticate?token=" +data.token)
                    }
                    else{
                        window.location.replace('https://e-campus.bp.edu/autologin.php?uid='+data.id)
                    }
               },30000)
    
           }
           else{
               setmessageHead("Error!!")
               setmessage("Some Error Occured")
               messageToggle();
                setRegistering(false)
    
           }
       }

    const refervalue = (e) => {
        setWhoreferredyou(e.target.value)
        if(e.target.value == "Other: Please specify source"){
            setShowOtherRefer(true)
        }
    }



    function ValidateEmail(mail) 
    {
     if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail))
      {
        return (true)
      }
        // alert("You have entered an invalid email address!")
        return (false)
    }
    return (

        <div className="main-bg">


            <Modal isOpen={successModal} toggle={successToggleModal} className="connect-box" centered={true}>
                <ModalHeader toggle={successToggleModal}><span className="ml-1 roititle font-weight-bold">Login</span></ModalHeader>
                <ModalBody>
                    <div className="modal-p">
                        <div>
                            <div className="wrp-login">

                                <div className="login-content">

                                    <div className="wrp-label">
                                        <label>Email Address</label>
                                        <input
                                            value={email} onChange={(e) => setEmail(e.target.value)}
                                            type="email"
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="wrp-label mrt-input">
                                        <label>Password</label>
                                        <input
                                            value={password} onChange={(e) => setpassword(e.target.value)}
                                            type="password"
                                            placeholder="Password"
                                        />
                                    </div>

                                    {
                                        alert &&
                                        <Alert color="danger">
                                            Invalid Login
                                        </Alert>
                                    }

                                    <button className="login-btn" type="submit" onClick={LoginUser} >Login </button>

                                </div>

                            </div>
                        </div>
                    </div>
                </ModalBody>

            </Modal>
            <Modal isOpen={programRequisitModal} toggle={()=>setProgramRequisitModal(!programRequisitModal)} className="connect-box" centered={true}>
                <ModalHeader toggle={()=>setProgramRequisitModal(!programRequisitModal)}><span className="ml-1 roititle font-weight-bold">Prerequisites</span></ModalHeader>
                <ModalBody>
                    <div className="modal-p" style={{fontSize: "14px"}}>
                          <div
        dangerouslySetInnerHTML={{ __html: prereq }}
      />
                    </div>
                </ModalBody>

            </Modal>
            <Header />

            <Faculty message={"Please fill the form below and checkout"} />
            <div className="wrp-welcome-page">
                <div className="container">
                    <div className="welcome-content">
                        {/* <div className="welcome-head">
                            <h3>WELCOME</h3>
                         <h4>Professional School of Behavioral Health Sciences</h4> 

                        </div> */}
                        <div className="registration-from">
                           
                            {/* <p>Please complete your Registration profile as shown below</p> */}
                            


                        </div>
                        {/* <div className='registration-from-bottom'>
                            <p>Upon completion of the program, you will receive a transcript and a Certificate of Completion by email.</p>
                        </div> */}
                    </div>
                </div>
                <form>
                    <div className='form-main-wrap'>
                        <div className='container-fluid'>
                            <div className='form-wrap'>
                                <ul className='form'>
                                   <small>Click here to <u><a href="#" onClick={()=>setProgramRequisitModal(!programRequisitModal)}>review program requirements</a></u>. If in doubt, be sure to contact us at  <u><a href="mailto:education@bp.edu">education@bp.edu</a></u>.<br/>
                                    If you're an existing student/faculty member please <u><a href="/">click here </a></u>to proceed to checkout.</small>
                                    <h3 className='mb-0 mt-2'>Registration Profile</h3>
                                    <li className='mt-1'>
              
              <div className='input-list'>
                  <p>First Name *</p>
                  <input type='text'     onChange={(e) => setFirstname(e.target.value)} style={errorBorder('firstname')} placeholder='Enter first name'></input>
                  {fieldError('firstname')}
              </div>
              <div className='input-list'>
                  <p>Last Name *</p>
                  <input type='text'    onChange={(e) => setLastname(e.target.value)} style={errorBorder('lastname')} placeholder='Enter last name'></input>
                  {fieldError('lastname')}
              </div>
              <div className='input-list'>
                  <p>Email Address (Username) *</p>
                  <input type='text' autoComplete='off'   onChange={(e) => setEmail(e.target.value)} style={errorBorder('email')} placeholder='Enter email'></input>
                  {fieldError('email')}
              </div>
              <div className='input-list'>
                  <p>Confirm Email Address *</p>
                  <input autoComplete='off'   onChange={(e) => setConfirmEmail(e.target.value)} style={errorBorder('confirmemail')} placeholder='Enter email'></input>
                  {fieldError('confirmemail')}
              </div>
              </li>
        
          <li>
              <div className='input-list'>
                  <p>Password *</p>
                  <input autoComplete='new-password'   onChange={(e) => setPassword(e.target.value)} style={errorBorder('password')} type='password' placeholder='Enter password'></input>
                  {fieldError('password')}
              </div>
              <div className='input-list'>
                  <p>Confirm Password *</p>
                  <input autoComplete='new-password'   onChange={(e) => setConfirmPassword(e.target.value)} style={errorBorder('confirmPassword')} type="password" placeholder='Enter password'></input>
                  {fieldError('confirmPassword')}
              </div>
              <div className='input-list'>
                  <p>Tel Office Number</p>
                  <input   onChange={(e) => setTelofficeNo(e.target.value)} type='text' placeholder='Enter office number'></input>
              </div>
              <div className='input-list'>
                  <p>Tel Cell Number  *</p>
                  <input   onChange={(e) => setTelcellNo(e.target.value)} style={errorBorder('telcellNo')} type='text' placeholder='Enter cell number'></input>
                  {fieldError('telcellNo')}
              </div>


          </li>
          <li>
              <div className='input-list2'>
                  <p>Address Line 1 *</p>
                  <input   onChange={(e) => setAddress1(e.target.value)} style={errorBorder('address1')} type='text' placeholder='Enter Street address'></input>
                  {fieldError('address1')}
              </div>
              <div className='input-list2'>
                  <p>Address Line 2 </p>
                  <input  onChange={(e) => setAddress2(e.target.value)} type='text' placeholder='Enter apartment, suite, unit etc (optional)'></input>
              </div>
          </li>
          <li>
                    {
                        countries.length > 0 &&
          <div className='input-list'>
                  <p>Country *</p>
                  <select className="" style={errorBorder('country')}   onChange={(e) => setCountry(e.target.value)} >
                      <option value={''}>Select Country</option>
                      {
                          countries.map((v,i) => {
                              return (
                                <option value={v.id}>{v.Name}</option>
                              )

                          })
                      }
                    
                  </select>
                  {fieldError('country')}
              </div>
                    }

              <div className='input-list'>
                  <p>State, province, other *</p>
                
                  {
                    states.length == 0 ?
                    <input   onChange={(e) => setState(e.target.value)} style={errorBorder('state')} type='text' placeholder='State, province, other *'></input>

                    :
                    <select className="" style={errorBorder('state')}   onChange={(e) => setState(e.target.value)} >
                    <option value={''}>Select State</option>
                    {
                        states.map((v,i) => {
                            return (
                              <option value={v.name}>{v.name}</option>
                            )

                        })
                    }
                  
                </select>
                  }
                  {fieldError('state')}
              </div>
              <div className='input-list'>
                  <p>City *</p>
                  <input   onChange={(e) => setCity(e.target.value)} style={errorBorder('city')} type='text' placeholder='Select city'></input>
                  {fieldError('city')}
              </div>
              <div className='input-list'>
                  <p>Postal Code *</p>
                  <input   onChange={(e) => setPostalcode(e.target.value)} style={errorBorder('postalcode')} type='text' placeholder='Enter postal code'></input>
                  {fieldError('postalcode')}
              </div>


          </li>
                                    <div className="professional-content">
                                        {/* <h3>Professional Certificate in NeuroAcrobatics™</h3> */}
                                        {/* <p className='text-justify'>If you plan to earn a <b>Professional Certificate in NeuroAcrobatics™ </b> by taking the subsequent two */}
                                            {/* webinars, click  here: <u><b style={{cursor: "pointer"}} onClick={() => setShow(!show)}>Professional Background Profile.</b></u>  */}
                                        {/* </p> */}
                                        {/* <p>If applicable, click here to complete your  (only for those interested in earning a Professional Certificate)</p> */}
                                    </div>

                                    {
                                        show ? <div>
                                          <ul className='form'>
                            <li>
                                <div className='input-list'>
                                    <p>Profession *</p>
                                    <input   onChange={(e) => setProfession(e.target.value)} style={errorBorder('profession')} type='text' placeholder=''></input>
                                    {fieldError('profession')}
                                </div>
                                <div className='input-list'>
                                    <p>Highest degree earned *</p>
                                    <input   onChange={(e) => setHighestdegreeearned(e.target.value)} style={errorBorder('highestdegreeearned')} type='text' placeholder=''></input>
                                    {fieldError('highestdegreeearned')}
                                </div>
                                <div className='input-list'>
                                    <p>Degree in what field *</p>
                                    <input   onChange={(e) => setDegreeinwhatfield(e.target.value)} style={errorBorder('degreeinwhatfield')} type='text' placeholder=''></input>
                                    {fieldError('degreeinwhatfield')}
                                </div>
                                <div className='input-list'>
                                    <p>Year degree earned *</p>
                                    <input   onChange={(e) => setyeardegreeearned(e.target.value)} style={errorBorder('yeardegreeearned')} type='text' placeholder=''></input>
                                    {fieldError('yeardegreeearned')}
                                </div>
                            </li>
                            <li>
                                <div className='input-list1'>
                                    <p>Licenses (Indicate NA if none.) *</p>
                                    <input   onChange={(e) => setLicenses(e.target.value)} style={errorBorder('licenses')} type='text' placeholder=''></input>
                                    {fieldError('licenses')}
                                </div>
                                <div className='input-list1'>
                                    <p>Certifications (Indicate NA if none.) *</p>
                                    <input type='text'   onChange={(e) => setCertifications(e.target.value)} style={errorBorder('certifications')} placeholder=''></input>
                                    {fieldError('certifications')}
                                </div>



                            </li>
                            <li>
                                <div className='input-list input-list4'>
                                    <p>Years of professional experience *</p>
                                    <input   onChange={(e) => setYearsofprofessionalexperience(e.target.value)} style={errorBorder('yearsofprofessionalexperience')} type='text' placeholder=''></input>
                                    {fieldError('yearsofprofessionalexperience')}
                                </div>
                                <div className='input-list input-list4'>
                                    <p>Who referred you?*</p>
                                    <select style={errorBorder('whoreferredyou')} onChange={refervalue} >
                                    <option value="" data-title="Website Link" data-id="0">Please Choose</option>
                                    <option value="School website or email" data-title="Website Link" data-id="0">School website or email</option>
                                       <option value="Social Media, e.g., Facebook" data-title="Website Link" data-id="1">Social Media, e.g., Facebook</option>
                                       <option value="Faculty, Student, or Admin" data-title="Specify name" data-id="1">Faculty, Student, or Admin</option>
                                       <option value="Employer" data-title="Specify Name" data-id="1">Employer</option>                                    
                                       <option value="Personal friend" data-title="Name" data-id="1">Personal friend</option>
                                       <option value="Professional colleague" data-title="Name" data-id="1">Professional colleague</option>
                                       <option value="Other: Please specify source" data-title="Name" data-id="1">Other: Please specify source</option>

                                    </select>
                                    {fieldError('whoreferredyou')}
                                </div>
                                {
                                showOtherRefer ?
                                <>                                
                                <div className='input-list'>
                                <p>Please specify source </p>
                                <input   onChange={(e) => setSource(e.target.value)} type='text' placeholder=''></input>
                                </div>
                                </>
                                :
                                null
                                }
                                <div className={showOtherRefer ? 'input-list' : 'list5'}>
                                    <p>Upload CV</p>
                                    <input type="file" id="myfile" name="myfile"  ref={cvFile}  >

                                    </input>
                                </div>
                                
                            </li> 
                        </ul>
                                        </div> : null
                                    }

                                {  rentalOption==1 && 
                    <div className="mt-4">
                    <p style={{fontSize:"16px",marginBottom:"10px",fontWeight:"bold"}}>
                     CapnoTrainer GO requirement:
                    </p>
                    <p style={{fontSize:"14px",marginBottom:"0px"}}>
                      Candidates are required to rent or own a CapnoTrainer to complete certification requirements with their own volunteer subjects.
                    </p>
                    <p style={{fontSize:"14px",marginBottom:"10px"}}>
                      The CapnoTrainer Rental Option is <strong>$600.00</strong> plus shipping. The rental fee may be applied as credit toward a subsequent CapnoTrainer purchase.
                    </p>
                    <p style={{fontSize:"14px",marginBottom:"10px",fontWeight:"bold",fontStyle:"italic"}}>
                     Please indicate below your intentions regarding CapnoTrainer instrumentation:
                    </p>
                     <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",

    }}
  >
    {/* Option 1 */}
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
     
      }}
    >
      <input
        type="radio"
        name="capnoOption"
        value={1}
        checked={rentalOpted === 1}
        onChange={() => setRentalOpted(1)}
        style={{ width: 12, height: 12 }}
      />
      <span style={{fontSize:"14px"}}>I already own a CapnoTrainer</span>
    </label>

    {/* Option 2 */}
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",

      }}
    >
      <input
        type="radio"
        name="capnoOption"
        value={2}
        checked={rentalOpted === 2}
        onChange={() => setRentalOpted(2)}
        style={{ width: 12, height: 12 }}
      />
      <span style={{fontSize:"14px"}}>I plan to buy a CapnoTrainer</span>
    </label>

    {/* Option 3 */}
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: "8px",

      }}
    >
      <input
        type="radio"
        name="capnoOption"
        value={3}
        checked={rentalOpted === 3}
        onChange={() => setRentalOpted(3)}
        style={{ width: 12, height: 12 }}
      />
      <span style={{fontSize:"14px"}}>I plan to rent a CapnoTrainer</span>
    </label>
  </div>
                    <p style={{fontSize:"14px",marginBottom:"10px"}}>
                     If you plan to rent an instrument, the rental option will appear in your confirmation email.
                    </p>
                    {fieldError('rentalOpted')}
                    </div>
                    }
                                        
                                    <div className='r-but2'>
                                        {
                                            creating ?
                                            <a  >REGISTERING...</a>
                                            :
                                            <a onClick={savaFormData} >REGISTER AND PAY NOW (${totalCost})</a>
                                            
                                            
                                        }
                                    </div>
                                </ul>
                            </div>
                        </div>
                    </div>
                </form>


                <form>
                    <div className='form-main-wrap'>
                        <div className='container'>

                        </div>
                    </div>
                </form>

            </div>


            <Modal isOpen={payPalModal} toggle={payPalToggle} className="connect-box" centered={true}>
            <ModalHeader toggle={payPalToggle}><span className="ml-1 roititle font-weight-bold">
            {
                            parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2) == 0 ?
                            <>
                            Amount Payable : ${parseFloat(totalCost -  totalCostDiscount).toFixed(2)}
                            </>
                            :
                            <>
                            Program Deposit : ${parseFloat(totalCost -  totalCostDiscount).toFixed(2)}
                             
                            </>
                    }
                    </span>
                
                </ModalHeader>
                <ModalBody>
                <div className="discount-btn">
                       
                       {
                        balanceDue > 0 &&
                        <div>
                            {/* <p className='mb-2'><b>Please choose how you would like to pay the remaining balance:</b></p> */}
                            <label style={paymentOptionStyle("deposit")}>
                                <input
                                    type="radio"
                                    name="paymentOption"
                                    value="deposit"
                                    checked={paymentOption == "deposit"}
                                    onChange={() => setPaymentOption("deposit")}
                                    style={{ width: 14, height: 14, marginTop: 3, flexShrink: 0 }}
                                />
                                <span>
                                    <b>Balance due 2 days before program starts:</b> ${balanceDue.toFixed(2)}
                                </span>
                            </label>
                            {
                                installments.length > 0 &&
                                <label style={paymentOptionStyle("installment")}>
                                    <input
                                        type="radio"
                                        name="paymentOption"
                                        value="installment"
                                        checked={paymentOption == "installment"}
                                        onChange={() => setPaymentOption("installment")}
                                        style={{ width: 14, height: 14, marginTop: 3, flexShrink: 0 }}
                                    />
                                    <span>
                                        <b>Pay the balance in {installments.length} installments</b><br />
                                        {
                                            installments.map((v, i) => {
                                                return (
                                                    <span key={i} style={{ display: "block" }}>
                                                        Installment {i + 1}: ${v.amount} due on {v.date}
                                                    </span>
                                                )
                                            })
                                        }
                                    </span>
                                </label>
                            }
                        </div>
                    }
                       {
                           scapplied ? 
                           <p className='text-success'><i className='fa fa-check-circle'></i> Scholarship Code Applied</p>:
                           poapplied ? 
                           <p className='text-success'><i className='fa fa-check-circle'></i> PO Number Applied</p>
                           :
                           null
                       }
                       {
                        parseFloat(balanceAmount - balanceAmountDiscount).toFixed(2) > 0 &&
                       <hr />
                    }
                       {
                           codeError ?
                           <small className='text-danger'><i className='fa fa-times'></i> {codeError}</small>
                           :
                           null

                       }

                       <div className="coupon-wrp mb-4 mt-2">
                           <div className="coupon-child1">
                               <label><b>Scholarship Code</b></label>
                               <input onChange={(e) => setScholarshipCode(e.target.value)} placeholder='Enter Scholarship Code' />
                               <button onClick={applyscholarshipcode}>Apply</button>
                           </div>
                           <div className="coupon-child1 coupon-right">
                                <label><b>PO # (Preapproved)</b></label>
                                <input onChange={(e) => setPoNumber(e.target.value)} placeholder='Enter PO Number' />
                               <button onClick={applyponumber}>Apply</button>
                           </div>
                       </div>
                       {
                           registering &&
                           <button disabled={true}>Completing Registration...</button>

                       }
                       {
                           totalCost == totalCostDiscount && !registering &&
                           <button onClick={() =>  completeRegisteration(existingUserId,'',0,0)}>CheckOut</button>
                       }
                    </div>
                    {
                           totalCost != totalCostDiscount &&
                           <>
                             <div
    data-pp-message
    data-pp-style-layout="text"
    data-pp-style-logo-type="inline"
    data-pp-style-text-color="black"
    data-pp-amount={totalCost}
    data-pp-placement="payment"
    data-pp-style-text-size="16" >
</div>
                            <div id="paypal-button-container">
                       
                       </div>
                     
                           </>
                          
                    }
{/* {
    existingUserId && showCheckout &&
    <div style={{textAlign: "center"}}>
        <button className='checkbtn' onClick={() =>  proceed()}>Checkout</button>
    </div>
} */}


                </ModalBody>

            </Modal>

            <Modal isOpen={messageModal} toggle={messageToggle} className="connect-box" centered={true}>
                <ModalHeader toggle={messageToggle}><span className="ml-1 roititle font-weight-bold">{messageHead}</span></ModalHeader>
                <ModalBody>
                    <div dangerouslySetInnerHTML={{__html : message}}>
                       
                    </div>
                </ModalBody>

            </Modal>
            <Modal isOpen={loginModel} toggle={LoginToggleModal} className="connect-box" centered={true}>
                <ModalHeader toggle={LoginToggleModal}><span className="ml-1 credentials-title">Please enter your e-campus credentials to checkout</span></ModalHeader>
                <ModalBody>
                    <div className="modal-p">
                            <div className='login-bg'>
                                <div className="wrp-login">

                                    <div className="login-content">
                                       
                                        <div className="wrp-label">
                                            <label>Email Address</label>
                                            <input
                                               
                                                type="email"
                                                placeholder="Email"
                                            />
                                        </div>
                                        <div className="wrp-label mrt-input">
                                            <label>Password</label>
                                            <div className="wrp-label" style={{ position: "relative" }}>
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    placeholder="Password"
                                                    style={{ paddingRight: "40px" }}
                                                />
                                                <i
                                                    className={showPassword ? "fa fa-eye-slash" : "fa fa-eye"}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", color: "#000" }}
                                                ></i>
                                            </div>
                                        </div>

                                       

                                        <button className="login-btn" type="submit"  >CheckOut</button>

                                    </div>

                                </div>
                            </div>
                    </div>
                </ModalBody>

            </Modal>
        </div>
    )
}
export default Create;